module.exports = __webpack_public_path__ + "static/agenda-color-item-titles-8f018cfc7e0047a78c64ecc4cf38d0aa.png";